import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './AdminLayout.css';

// SVG icon components
const Icon = ({ d, d2, viewBox = '0 0 24 24' }) => (
  <svg width='18' height='18' viewBox={viewBox} fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
    {d2}
  </svg>
);

const NAV_SECTIONS = [
  {
    label: 'Overview',
    items: [
      { to: '/admin/dashboard', label: 'Dashboard', icon: <Icon d={['M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z']} d2={<polyline points='9 22 9 12 15 12 15 22'/>} /> },
    ]
  },
  {
    label: 'Content',
    items: [
      { to: '/admin/products',   label: 'Products',    icon: <Icon d={['M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4']} /> },
      { to: '/admin/hero',       label: 'Hero Slider', icon: <Icon d={['M15 10l4.553-2.069A1 1 0 0 1 21 8.87V15.13a1 1 0 0 1-1.447.9L15 14M3 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3z']} /> },
      { to: '/admin/advantages', label: 'Advantages',  icon: <Icon d={['M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0']} /> },
      { to: '/admin/resources',  label: 'Resources',   icon: <Icon d={['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z', 'M14 2v6h6']} d2={<><line x1='16' y1='13' x2='8' y2='13'/><line x1='16' y1='17' x2='8' y2='17'/><polyline points='10 9 9 9 8 9'/></>} /> },
      { to: '/admin/dealers',    label: 'Dealers',     icon: <Icon d={['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M23 21v-2a4 4 0 0 0-3-3.87']} d2={<><circle cx='9' cy='7' r='4'/><path d='M16 3.13a4 4 0 0 1 0 7.75'/></>} /> },
    ]
  },
  {
    label: 'Pages',
    items: [
      { to: '/admin/home',            label: 'Home Page',       icon: <Icon d={['M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z']} d2={<polyline points='9 22 9 12 15 12 15 22'/>} /> },
      { to: '/admin/other-products',   label: 'Other Products',  icon: <Icon d={['M12 3l9 4.5v9L12 21l-9-4.5v-9L12 3z','M12 3v18','M3 7.5l9 4.5 9-4.5']} /> },
      { to: '/admin/navigation', label: 'Navigation',  icon: <Icon d={['M3 12h18', 'M3 6h18', 'M3 18h18']} /> },
      { to: '/admin/about',      label: 'About Us',    icon: <Icon d={['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M23 21v-2a4 4 0 0 0-3-3.87']} d2={<><circle cx='9' cy='7' r='4'/><path d='M16 3.13a4 4 0 0 1 0 7.75'/></>} /> },
      { to: '/admin/gem',        label: 'GeM Portal',  icon: <Icon d={['M12 2L2 7l10 5 10-5-10-5z', 'M2 17l10 5 10-5', 'M2 12l10 5 10-5']} /> },
      { to: '/admin/contact',    label: 'Contact Us',  icon: <Icon d={['M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z']} /> },
      { to: '/admin/footer',     label: 'Footer',      icon: <Icon d={['M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18']} /> },
    ]
  },
  {
    label: 'System',
    items: [
      { to: '/admin/settings',   label: 'Settings',    icon: <Icon d={['M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z']} /> },
    ]
  },
];

const AdminLayout = ({ children }) => {
  const navigate  = useNavigate();
  const [sideOpen, setSideOpen] = useState(true);

  const logout = () => {
    sessionStorage.removeItem('zinga_admin');
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className={`adm-layout${sideOpen ? '' : ' adm-layout-collapsed'}`}>
      {/* Sidebar */}
      <aside className='adm-sidebar'>
        <div className='adm-sidebar-brand'>
          <div className='adm-brand-logo'>Z</div>
          {sideOpen && <div>
            <div className='adm-brand-text'>ZINGA Admin</div>
            <div className='adm-brand-sub'>John Galt Technologies</div>
          </div>}
        </div>

        <nav className='adm-sidebar-nav'>
          {NAV_SECTIONS.map(section => (
            <div key={section.label} className='adm-nav-group'>
              {sideOpen && <div className='adm-nav-section-label'>{section.label}</div>}
              {section.items.map(item => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) => `adm-nav-link${isActive ? ' active' : ''}`}
                  title={item.label}
                >
                  <span className='adm-nav-icon'>{item.icon}</span>
                  {sideOpen && <span className='adm-nav-label'>{item.label}</span>}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className='adm-sidebar-footer'>
          <button className='adm-nav-link adm-logout-btn' onClick={logout} title='Logout'>
            <span className='adm-nav-icon'>
              <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4'/>
                <polyline points='16 17 21 12 16 7'/>
                <line x1='21' y1='12' x2='9' y2='12'/>
              </svg>
            </span>
            {sideOpen && <span className='adm-nav-label'>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main area */}
      <div className='adm-main'>
        <header className='adm-topbar'>
          <button className='adm-toggle-btn' onClick={() => setSideOpen(s => !s)} title='Toggle sidebar'>
            <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'>
              <line x1='3' y1='6' x2='21' y2='6'/><line x1='3' y1='12' x2='21' y2='12'/><line x1='3' y1='18' x2='21' y2='18'/>
            </svg>
          </button>
          <div className='adm-topbar-title'>
            ZINGA® Website Admin
          </div>
          <div className='adm-topbar-right'>
            <span className='adm-admin-badge'>Admin</span>
            <a href='/' target='_blank' rel='noopener noreferrer' className='adm-view-site-btn'>
              View Site ↗
            </a>
          </div>
        </header>

        <div className='adm-content'>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
